import styled from "styled-components"
import { Box } from "@components/Layout"
import { ParagraphS, Label } from "@components/Typography"
import { breakpoints } from "@config/theme"

export const Title = styled(Label)`
  margin: 0 0 1rem;
`

export const Wrapper = styled(Box)`
  display: block;
  width: 100%;
  padding-bottom: 2rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid ${(p) => p.theme.colors.softGrey};
`

export const Items = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 0.5rem;

  @media screen and (min-width: ${breakpoints.medium}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

export const Key = styled(ParagraphS)`
  color: ${(p) => p.theme.colors.text.light};
  flex: 0 0 25%;
  margin-bottom: 0rem;

  @media screen and (max-width: ${breakpoints.small}) {
    flex: 0 0 40%;
  }
`

export const Value = styled(ParagraphS)`
  flex: 0 0 75%;
  margin: 0 0 0.5rem;

  @media screen and (max-width: ${breakpoints.small}) {
    flex: 0 0 60%;
  }
`
